<div class="controls-group" [formGroup]="form" *ngIf="form">
  <app-row class="no-gutters" [ngClass]="{'flag-dir': isRtl}" justify="space-between">
    <app-col cols="12">
      <mat-label class="text-900 weight-medium">{{"Inputs.MobileNumber" | translate}}</mat-label>
    </app-col>

    <div class="country-list" [ngClass]="{'mr-2': !isRtl, 'ml-2': isRtl}">
      <!-- One offered country: a fixed prefix, since a dropdown with a single option is a dead click. -->
      <mat-form-field appearance="outline" dir="ltr" *ngIf="singleCountry; else countryPicker" class="controls-group__first-control country-static">
        <span matPrefix class="country-static__flag fi fi-{{ singleCountry.isoCode | lowercase }}"></span>
        <input matInput readonly tabindex="-1" [value]="singleCountry.phoneKey" [attr.aria-label]="'Inputs.CountryCode' | translate" />
      </mat-form-field>

      <ng-template #countryPicker>
      <mat-form-field appearance="outline" *ngIf="form.get('code') as code" class="controls-group__first-control">
        <mat-select [dir]="'ltr'" [hideSingleSelectionIndicator]="true" #countrySelect="matSelect" formControlName="code">
          <mat-select-trigger>
            <ng-container *ngFor="let c of countries">
              <span class="flex align-items-center px-1" *ngIf="c.phoneKey === countrySelect.value">
                <bdi>
                  <span class="fi fi-{{ c.isoCode | lowercase }}" [ngClass]="{'mr-1': isRtl}"></span>
                  {{ c.phoneKey }}
                </bdi>
              </span>
            </ng-container>
          </mat-select-trigger>
          <mat-option *ngFor="let country of countries" [value]="country.phoneKey">
            <span class="d-flex align-items-center">
              <bdi class="flex align-center">
                <span class="fi fi-{{ country.isoCode | lowercase }} mr-2"></span>
                <span class="flex">{{ country.phoneKey }}</span>
              </bdi>
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>
      </ng-template>
    </div>

    <app-col>
      <mat-form-field appearance="outline" *ngIf="form.get('number') as number" class="controls-group__last-control">
        <input
          [ngClass]="{'input-ltr': isRtl}"
          matInput
          type="text"
          formControlName="number"
          [placeholder]="'Placeholder.EnterYourMobile' | translate"
        />
        <div class="controls-group__error mt-3">
          <ng-content select="[error], mat-error, error"></ng-content>
        </div>
      </mat-form-field>
    </app-col>

    <div class="col-12 small" *ngIf="form.get('number') as number">
      <mat-error *ngIf="number.invalid && number.dirty && numberErrorKey">
        {{ numberErrorKey | translate: {length: MobileLengthPerCode[form.value.code]} }}
      </mat-error>
    </div>
  </app-row>
</div>
